import { render, staticRenderFns } from "./HeroModule.vue?vue&type=template&id=77230b3e&scoped=true&"
import script from "./HeroModule.vue?vue&type=script&lang=js&"
export * from "./HeroModule.vue?vue&type=script&lang=js&"
import style0 from "./HeroModule.vue?vue&type=style&index=0&id=77230b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77230b3e",
  null
  
)

export default component.exports